"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYAMLValidity = getYAMLValidity;
var _jsYaml = require("js-yaml");
function getYAMLValidity(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  try {
    (0, _jsYaml.load)(input);
    return "YAML is valid!";
  } catch (e) {
    throw e;
  }
}